module.exports = __webpack_public_path__ + "static/media/google-play.56bec84d.svg";